import { getEnv } from './env'

/**
 * 根据当前所在区域，以及路径拼接完整前端oss的url地址
 * @param path 路径，不包含协议和host
 * @returns 完整url地址
 */
export const getFeUrl = (path: string) => {
  return `${getEnv('feOss')}${path}`
}

/**
 * 根据当前所在区域，以及路径拼接完整后端oss的url地址
 * @param path 路径，不包含协议和host
 * @returns 完整url地址
 */
export const getBeUrl = (path: string) => {
  return `${getEnv('beOss')}${path}`
}

/**
 *
 * @param path 路径，不包含协议和host
 * @returns 完整url地址
 */
export const useCssBgUrl = (path: string) => {
  return computed(() => `url(${getFeUrl(path)})`)
}
